function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M25 33.33c-4.1 0-7.75-3.32-9.26-8.34-1.38-.08-2.4-1.84-2.4-4.16 0-.66.09-1.31.25-1.89-.17-.84-.25-1.57-.25-2.28C13.33 10.23 18.57 5 25 5s11.67 5.23 11.67 11.67c0 .71-.08 1.44-.25 2.28.17.58.25 1.23.25 1.89 0 2.32-1.03 4.08-2.4 4.16-1.52 5.02-5.17 8.33-9.27 8.33zm-8.68-10.14c.1 0 .2.02.29.05.25.1.46.29.52.55 1.17 4.7 4.33 7.87 7.86 7.87s6.7-3.16 7.86-7.87c.06-.26.25-.47.5-.57.25-.1.53-.08.75.07.32.05.89-.84.89-2.46 0-.57-.08-1.12-.24-1.59a.733.733 0 01-.02-.44c.19-.8.27-1.48.27-2.13 0-5.51-4.49-10-10-10s-10 4.49-10 10c0 .65.08 1.33.26 2.14.03.15.02.3-.02.44-.16.47-.24 1.01-.24 1.58 0 1.61.63 2.5.83 2.5.15-.09.32-.14.49-.14z",
  fill: "#212121"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M44.17 45H5.83c-.46 0-.83-.37-.83-.83v-1.22c0-4.61 2.92-8.72 7.28-10.23l4.29-1.49c.31-.11.66-.02.89.22C19.55 33.74 22.23 35 25 35c2.77 0 5.45-1.26 7.55-3.56.22-.24.57-.33.89-.22l4.29 1.49A10.84 10.84 0 0145 42.94v1.22c0 .47-.37.84-.83.84zm-37.5-1.67h36.67v-.39c0-3.9-2.47-7.38-6.16-8.66l-3.78-1.31c-2.36 2.39-5.33 3.7-8.4 3.7-3.07 0-6.03-1.31-8.4-3.7l-3.78 1.31a9.18 9.18 0 00-6.16 8.66v.39zM33.33 20c-.33 0-.63-.19-.76-.49-.03-.07-.64-1.46-.84-2.86-3.49-.23-7.11-1.94-8.91-3.71-.15.26-.34.51-.56.73-1.34 1.33-3.46 1.36-4.55 1.35-.24.56-.35 2.37-.22 4.11.02.25-.08.5-.27.67-.19.17-.44.25-.69.21-.01 0-1.15-.17-2.09-.17-.46 0-.83-.37-.83-.83s.37-.83.83-.83c.45 0 .93.03 1.34.07-.05-1.51.03-3.66.77-4.46.31-.33.71-.42 1.17-.42 1 0 2.55-.05 3.36-.86.39-.39.58-.92.58-1.64 0-.46.37-.83.83-.83.46 0 .83.37.83.83.1.84 4.28 4.17 9.17 4.17.46 0 .83.37.83.83 0 .82.32 1.84.55 2.45l1.6-.13c.45-.03.86.3.9.76.04.46-.3.86-.76.9L33.4 20h-.07z",
  fill: "#212121"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.5 21.67h-1.67c-.46 0-.83-.37-.83-.83s.37-.84.83-.84h1.67c.46 0 .83.37.83.83s-.37.84-.83.84zm6.67 0H27.5c-.46 0-.83-.37-.83-.83s.37-.84.83-.84h1.67c.46 0 .83.37.83.83s-.37.84-.83.84z",
  fill: "#212121"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 50 50"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/boy.d491e98d.svg";
export { SvgComponent as ReactComponent };